import type { SimpleMesh2d } from "."
import { packMesh } from "./packMesh"
import { extractMeshFromStore, drawFaces } from "../../mesh"
import type { Face2dComputed } from "../../mesh"
import type { Identified } from "../../utils"

export const meshToFaces = (
  mesh: SimpleMesh2d,
): (Face2dComputed & Identified)[] => {
  const meshPacked = packMesh(mesh)
  const meshExtracted = extractMeshFromStore(meshPacked)
  const { faces } = drawFaces(meshExtracted.nodes, meshExtracted.edges)

  return [...faces.entries()].map(([faceId, face]) => ({
    id: faceId,
    nodes: face.nodeIds.map((id) => ({ ...meshPacked.getNode(id), id })),
  }))
}
